<template>

  <div>

    <t-form-list :generalErrors="generalErrors" :items="items" :fields="fields" :command="command" :user-auth="userAuth"
                 :status="status"
                 :path="path"
                 :busy="!pageFormIsLoaded" :busy-form="!listFormIsLoaded" :busy-list="!listIsLoaded"
                 primary-key-column="quoteEquipmentId"
                 :primary-key="form.quoteEquipmentId"
                 :foreign-key-column="foreignKeyColumn"
                 :foreign-key="foreignKey"
                 sortable
                 enable-change-order-up-down
                 disable-footer-length
                 @onChangeOrder="getList"
                 @onSubmit="onSubmit" @onItemRead="onItemReadDefault" @onItemDelete="onItemDeleteDefault">

      <t-input v-model="form.quoteEquipmentId" hidden/>

      <b-col cols="12" class="mb-2">

        <b-row>

          <b-col xl="9">

            <b-row>

              <b-col cols="6">

                <t-input-code-label :status="status" :add-error="error.typeEquipmentId" ref="firstInput"
                                    type-equipment
                                    @onResume="setUnitPriceDefault"
                                    @focusout="focusByRef('input_quantity')" :command="command"
                                    v-model="form.typeEquipmentId" required/>
              </b-col>

              <t-input cols="2" v-model="form.quantity" number :decimals="4" ref="input_quantity"
                       label="Qtd." required/>

              <t-input cols="2" v-model="form.unitPrice" submitted number :decimals="2"
                       label="Valor Un." required/>

              <t-input cols="6" textarea v-model="form.note"
                       label="Obs." max-length="2000"/>

              <b-col xl="3" class="button-form-inline">

                <t-button :sending="status === 'sending'" tabindex="3" :text="onButtonSubmitText(command)" no-icon
                          submit/>

                <b-link class="ml-2 text-focus" v-if="command === 'update'" @click="cancelUpdatedList()">
                  {{ t('go-back') }}
                </b-link>

              </b-col>

            </b-row>

            <!--            <t-input cols="3" v-model="form.note" label="Observação"/>-->

          </b-col>


        </b-row>

      </b-col>

      <template #item(typeEquipment)="{item}">
        <span>{{ item.typeEquipmentCodeLabel }} - {{ item.typeEquipment }}</span>
        <small v-if="item.note !== ''"><br/>{{ item.note }}</small>
      </template>


    </t-form-list>

  </div>

</template>

<script>
import pageDefaultMixin from "@/mixins/page/pageDefaultMixin"
import pageFormMixin from "@/mixins/page/pageFormMixin"
import pageFormListMixin from "@/mixins/page/pageFormListMixin"
import tFormList from "@/components/template/form/list/t-form-list"

export default {
  mixins: [pageDefaultMixin, pageFormMixin, pageFormListMixin],
  components: {tFormList},
  name: 'QuoteEquipment',
  data() {
    return {
      path: "business/quote-equipment", //Utilizar somente quando fora do padrão
      foreignKeyColumn: "quoteId", //Utilizar quando usar Tabs com outros componentes
      fields: [
        {keyRead: "quoteEquipmentId", keyDelete: "quoteEquipmentId"},
        {key: "firstFileId", label: "", cols: "1"},
        {key: "typeEquipment", label: "Equipamento", cols: "3"},
        {key: "unitPrice", label: "Valor Un.", cols: "3", formatter: "money"},
        {key: "quantity", label: "Qtd.", cols: "2", formatter: "number"},
        {key: "totalPriceSale", label: "Valor Total", cols: "3", formatter: "money"},
      ],
      form: {
        quoteId: this.foreignKey,
        quoteEquipmentId: 0,
        typeEquipmentId: 0,
        quantity: 1,
        unitPrice: 0,
        note: "",
        status: 1,
      },
      error: {//Campos que podem receber retorno de erro do backend
        typeEquipmentId: "",
      },
    }
  },
  props: {
    customerId: {
      type: Number,
      required: false,
      default: 0,
    },
  },
  computed: {
    onForm() {
      return this.form
    }
  },
  methods: {


    defaultForm() {

      //Preenche somente os campos que foram limpos após o reset
      this.defaultFormList()

      this.focusByRef('firstInput')

    },

    mountedPrepare() {

      this.mountedPrepareFormListDefault()

    },

    async mountedContinued() {


      await this.getList()

    },

    async onSubmit() {

      await this.setSendingFormListDefault(this.form.quoteEquipmentId)


    },

    mountedList() {

      this.focusByRef('firstInput')

      this.listIsLoaded = true

    },
    //--------------------------------------------------------------------------------------
    //Início de métodos personalizados desta tela
    setUnitPriceDefault(value) {
      console.log(value)
    }
    //--------------------------------------------------------------------------------------
  },
  async mounted() {

    this.mountedPrepare()

    await this.mountedFormList()

    await this.mountedContinued()

  },
}
</script>
